
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Loading, DatePicker,LoadingTemplateType } from '@/components';
import {
  Utente,
  LavorazionePerSpedizione,
  ProgressoSpedizione,
  PreparazionePerSpedizione,
  Mapper,
  ProxyProgressoSpedizione
} from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import dayjs from 'dayjs';

@Component({
  components: {
    Loading,
    DatePicker
  }
})
export default class NuovaSpedizione extends Vue {
  private dialog = false;
  private spedizioneCreata = false;
  private formValido = true;
  private idSpedizione = '';
  private numDDT = '';
  private numColli = 1;
  private dataDDT = new Date().toISOString().substr(0, 10);
  private notaDDT = '';
  private regoleValidazione = {
    maggioreUgualeZero: (value: number): boolean | string =>
      value >= 0 || 'Il valore non può essere inferiore a zero.',
    minoreStatoIniziale: (statoIniziale: number) => (value: number) =>
      statoIniziale >= value ||
      `Le lavorazioni che si vogliono inviare non possono essere superiori a quelle disponibili (${statoIniziale} disponibili)`
  };

  resetDatiDDT() {
    this.numDDT = '';
    this.numColli = 1;
    this.dataDDT = new Date().toISOString().substr(0, 10);
    this.notaDDT = '';
    this.progressiSelezionati = [];
  }

  get datiValidi(): boolean {
    return (
      this.numColli > 0 &&
      this.numDDT.length > 0 &&
      this.progressiSelezionati.length > 0
    );
  }

  get user() {
    return store.state.currentUsr;
  }

  get loading() {
    return store.state.loading;
  }

  private progressiSpedizioni = new Array<ProxyProgressoSpedizione>();
  private progressiSelezionati = new Array<string>();

  get righeInviabili(): PreparazionePerSpedizione[] {
    let righeInviabili = this.righeFiltrate.map(r => {
      let rigaProg = this.progressiSpedizioni.find(
        p => p.progressoSpedizione.idLavorazione == r.id
      );
      if (!rigaProg) {
        rigaProg = new ProxyProgressoSpedizione(
          Mapper.LavorazionePerSpedizioneToProgressoSpedizione(r)
        );
        this.progressiSpedizioni.push(rigaProg);
      }

      let rigaPrep: PreparazionePerSpedizione = {
        lavorazioneSpedizione: r,
        rigaSpedizione: rigaProg,
        desc: `${r.codiceLAK}${r.firstCost == 'S' ? ' USA' : ''}${
          r.campionario ? ' CAMPIONARIO' : ''
        } ${r.stagione.id} ${r.stagione.descrizione} ${r.lineaVendita?.id ?? ""} ${
          r.lineaVendita?.descrizione ?? ""
        } ${r.fase.id} ${r.fase.descrizione} ${r.lotto} ${r.codiceConsegna} ${
          r.modello.codiceParte
        } ${r.modello.descrizione} ${r.colore.codiceColore} ${
          r.colore.descrizione
        }`
      };

      return rigaPrep;
    });

    return righeInviabili;
  }

  get righeFiltrate(): LavorazionePerSpedizione[] {
    let righe = store.state.lavorazioniPerSpedizione
      .concat()
      .sort((lavA, lavB) => {
        if (lavA.progresso > lavB.progresso) {
          return 1;
        }
        if (lavA.progresso < lavB.progresso) {
          return -1;
        }
        // if (lavA.priorita < lavB.priorita) { return 1; }
        // if (lavA.priorita > lavB.priorita) { return -1; }
        if (lavA.dataConsegna > lavB.dataConsegna) {
          return 1;
        }
        if (lavA.dataConsegna < lavB.dataConsegna) {
          return -1;
        }
        return 0;
      });

    // TODO: più corretto mettere un watch a parte
    this.progressiSelezionati = righe.map(r => r.id);

    return righe;
  }

    get loadTemplateCorrente() : LoadingTemplateType {
    return LoadingTemplateType.CreaSpedizione;
  }

  async creaSpedizione() {
    const datiSpedizione = {
      righe: this.progressiSpedizioni
        .filter(
          p =>
            this.progressiSelezionati.indexOf(
              p.progressoSpedizione.idLavorazione
            ) > -1
        )
        .map(p => p.toProgressoSpedizione()),
      numeroDDT: this.numDDT,
      dataDDT: dayjs(this.dataDDT).toISOString(),
      numColli: this.numColli,
      notaSpedizione: this.notaDDT
    };

    let esitoSpedizioneCreata = await store.dispatch(
      StoreActions.CreaSpedizione,
      datiSpedizione
    );

    if (esitoSpedizioneCreata[0]) {
      this.spedizioneCreata = true;
      this.idSpedizione = esitoSpedizioneCreata[1];
    }
  }

  stampaSpedizione(): void {
    if (!this.idSpedizione || this.idSpedizione.length === 0) {
      console.error("L'id della spedizione non esiste.");
      return;
    }

    window.open(`/ddt/${this.idSpedizione}`, '_blank');
  }

  @Watch('dialog')
  closeCreazioneSpedizioneDialog(opened: boolean, oldState: boolean) {
    if (!opened && opened !== oldState) {
      this.resetDatiDDT();
      store.dispatch(
        StoreActions.GetRigheSpedizionePerFornitore,
        this.user.idFornitore
      );
    }
  }

  created(): void {
    // TODO: caricamento nuove entità... riga con num capi inviabili in base a progresso lavorazione e prorgesso spedizione
    store.dispatch(
      StoreActions.GetRigheSpedizionePerFornitore,
      this.user.idFornitore
    );
  }

  private mounted() {
    //store.dispatch(StoreActions.WatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }

  private destroyed() {
    //store.dispatch(StoreActions.UnwatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }
}
